// Shared building blocks reused across study configs.
export const same = (...labels) => labels.map((l) => ({ value: l, label: l }));
export const TF = [
  { value: 'True', label: 'True' },
  { value: 'False', label: 'False' },
  { value: 'DK', label: "Don't know" },
];
// Knowledge MCQs always end with a "Don't know" (value 'DK') so students aren't
// forced to guess — this avoids inflating knowledge scores. DK never matches an
// answer key, so it scores 0 (same as a wrong answer) while staying distinguishable
// from a genuine misconception in the data.
export const mc = (...labels) => [...labels.map((label, i) => ({ value: 'abcde'[i], label })), { value: 'DK', label: "Don't know" }];

// Pre-clinical escape for self-reported PRACTICE items: 1st/2nd-year students who
// aren't seeing patients yet shouldn't be forced into a misleading "Never". Value is
// 'na_clinic' (the same PRACTICE_NA sentinel the score function excludes) so every
// pre-clinical answer codes identically across studies, scored or not.
export const NOT_YET_SEEING = { value: 'na_clinic', label: 'Not yet seeing patients' };

// Generic demographics reused by the new cross-sectional studies.
export const baseDemographics = [
  { key: 'A1', field: 'age', type: 'number', stem: 'Your age (in completed years)', min: 18, max: 60, required: true },
  { key: 'A2', field: 'sex', type: 'single', stem: 'Sex', options: same('Male', 'Female', 'Prefer not to say'), required: true },
  { key: 'A3', field: 'cohort', type: 'single', stem: 'Current level of training', required: true,
    options: [
      { value: '1st', label: 'First-year BDS' },
      { value: '2nd', label: 'Second-year BDS' },
      { value: '3rd', label: 'Third-year BDS' },
      { value: 'final', label: 'Final-year BDS' },
      { value: 'intern', label: 'Intern (rotating)' },
      { value: 'pg', label: 'Postgraduate' },
    ] },
];

// Audience roles for the eligibility-screening gate (open studies).
export const ROLES = [
  { value: 'student', label: 'Dental undergraduate (BDS) student' },
  { value: 'intern', label: 'Dental intern / house surgeon' },
  { value: 'pg', label: 'Dental postgraduate / resident' },
  { value: 'faculty', label: 'Dental faculty / practitioner' },
  { value: 'other', label: 'Other / none of the above' },
];
export const roleLabel = (v) => (ROLES.find((r) => r.value === v) || {}).label || v;

// Standard section titles/instructions used by the runner.
export const SECTION_META = {
  demographics: { title: 'About you' },
  knowledge: { title: 'Knowledge', instruction: 'Choose the single best answer.' },
  attitude: { title: 'Attitude', instruction: 'Indicate how strongly you agree or disagree.' },
  selfEfficacy: { title: 'Confidence', instruction: 'How confident do you feel? Indicate how strongly you agree or disagree.' },
  practice: { title: 'Practice', instruction: 'Answer based on current guidelines and your own experience.' },
};

// The order sections are presented in the runner and iterated in analytics. A study
// only shows the sections it actually declares (empty ones are skipped), so adding a
// new construct (e.g. selfEfficacy) never creates blank pages for studies without it.
// selfEfficacy is a separately-scored Likert construct (summed, no reverse-coding);
// scored applied vignettes (V*) and descriptive behavioural-intention (IN*) items live
// inside the practice section. demographics is baseline-only; the rest repeat pre/post.
export const SECTION_SEQUENCE = ['demographics', 'knowledge', 'attitude', 'selfEfficacy', 'practice'];

// Formal consent / ethics details shown on the consent page (and required by IRBs
// and most journals). EDIT THESE before collecting real data — set the IEC approval
// reference and a real contact. Empty fields degrade gracefully in the UI.
export const ETHICS = {
  controller: 'Eddlynn Edtech Private Limited',
  retentionYears: 5,
  contact: '',  // TODO: principal-investigator contact email
  iecRef: '',   // TODO: Institutional Ethics Committee approval reference
};
